import close_icon_purple from 'src/assets/close_icon_purple.png';

import { ModalProvider } from 'styled-react-modal'
import { StyledJournalModal, FadingBackground, ModalCloseButton } from './JournalStyles'
import React, { useState } from 'react'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { useContext } from 'react'
import BrowseJournals from './Pages/BrowseJournals'
import UserJournals from './Pages/UserJournals'
import NewJournal from './Pages/NewJournal'

export default function Journal(props) {
  const [opacity, setOpacity] = useState(0)
  const { journalData, setJournalData } = useContext(JournalContext)
  const [modalState, setModalState] = useState('loading')
  const [newEntryData, setNewEntryData] = useState()

  function toggleModal(e) {
    setOpacity(0)
    setJournalData({
      showJournal: false,
      callSource: '',
      data: '',
      pageState: '',
      subscription: '',
    })
  }

  function afterOpen() {
    setupPage()
    setTimeout(() => {
      setOpacity(1)
    }, 100)
  }

  function beforeClose() {
    return new Promise((resolve) => {
      setOpacity(0)
      setTimeout(resolve, 300)
    })
  }

  function setupPage() {
    if (journalData?.callSource === 'quote') {
      setModalState('user_journals')
    } else if (journalData?.callSource === 'navbar') {
      setModalState('user_journals')
    } else if (journalData?.callSource === 'tilespage') {
      setNewEntryData(journalData?.data)
      setModalState('new_journal')
      setJournalData((prev) => {
        return {
          ...prev,
          pageState: 'new_journal',
          subscription: journalData?.data?.subscription?.id,
        }
      })
    } else if (journalData?.callSource === 'daily-play') {
      setNewEntryData(journalData?.data)
      setModalState('new_journal')
      setJournalData((prev) => {
        return {
          ...prev,
          pageState: 'new_journal',
          subscription: journalData?.data?.subscription?.id,
        }
      })
    }
  }

  function setParentModalState(param) {
    setModalState(param)
  }

  return (
    <ModalProvider backgroundComponent={FadingBackground}>
      <StyledJournalModal
        isOpen={journalData?.showJournal}
        afterOpen={afterOpen}
        beforeClose={beforeClose}
        onEscapeKeydown={toggleModal}
        opacity={opacity}
        backgroundProps={{ opacity }}
      >
        {(modalState === 'user_journals' || modalState === 'browse_journals') && (
          <ModalCloseButton
            src={close_icon_purple}
            onClick={() => toggleModal()}
          />
        )}

        {modalState === 'user_journals' && (
          <UserJournals
            setParentModalState={setParentModalState}
            setNewEntryData={setNewEntryData}
            afterSubmitFunction={journalData?.afterSubmitFunction}
          />
        )}

        {modalState === 'browse_journals' && (
          <BrowseJournals
            setParentModalState={setParentModalState}
            setNewEntryData={setNewEntryData}
          />
        )}

        {modalState === 'new_journal' && (
          <NewJournal
            setParentModalState={setParentModalState}
            newEntryData={newEntryData}
            toggleModal={() => toggleModal()}
            afterSubmitFunction={journalData?.afterSubmitFunction}
          />
        )}
      </StyledJournalModal>
    </ModalProvider>
  )
}
